import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'shared/feature-flags';
import ApplicationsTeamScreen from '../components/applications-v2/applications-team-screen';
import ApplicationsTeamsScreen from '../components/applications-v2/applications-teams-screen';
import ChampionshipApplications from '../components/championship-teams/championship-applications';
import TeamPlayersPage from './team-players-page';

type ChampionshipApplicationsPageProps = {
  championshipId: number;
};

/**
 * Вкладка «Заявки» соревнования — развилка двух флоу.
 *
 * Адреса у обоих одинаковые (`/championships/:id/applications[/:teamId]`), различается
 * только набор экранов: флаг `applicationsFlowV2` включает второй вариант тем, кто
 * зарегистрировался после даты отсечки, либо тем, кому его включили вручную (`?flow=v2`).
 * Значение по умолчанию — старый флоу.
 */
const ChampionshipApplicationsPage = ({ championshipId }: ChampionshipApplicationsPageProps) => {
  const isFlowV2 = useFeatureFlag('applicationsFlowV2');

  return (
    <Routes>
      <Route path=":teamId" element={isFlowV2 ? <ApplicationsTeamScreen championshipId={championshipId} /> : <TeamPlayersPage />} />
      <Route
        path="*"
        element={
          isFlowV2 ? (
            <ApplicationsTeamsScreen championshipId={championshipId} />
          ) : (
            <ChampionshipApplications championshipId={championshipId} />
          )
        }
      />
    </Routes>
  );
};

export default ChampionshipApplicationsPage;
